import KmxInfoCircleFilled from '@kmx/mui-icons/KmxInfoCircleFilled';
import KmxInfoCircleStroked from '@kmx/mui-icons/KmxInfoCircleStroked';
import IconButton, { type IconButtonProps } from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import { memo } from 'react';

const StyledButton = styled(IconButton, {
  shouldForwardProp: (prop) => prop !== 'fontSize',
})<IconButtonProps & { fontSize?: number }>(({ fontSize }) => ({
  '--IconButton-hoverBg': 'transparent',
  fontSize,
  padding: 0,
}));

type InfoButtonProps = {
  iconSize?: number;
  variant?: 'filled' | 'stroked';
} & Omit<IconButtonProps, 'variant'>;

const InfoButton = ({
  iconSize = 14,
  onClick,
  variant = 'filled',
  ...rest
}: InfoButtonProps) => {
  const ariaLabel = rest['aria-label'] ?? 'More info';

  return (
    <StyledButton
      aria-label={ariaLabel}
      color="secondary"
      data-ignore-anchor-tag-rule
      fontSize={iconSize}
      onClick={onClick}
      size="small"
      {...rest}
    >
      {variant === 'stroked' ? (
        <KmxInfoCircleStroked fontSize="inherit" />
      ) : (
        <KmxInfoCircleFilled fontSize="inherit" />
      )}
    </StyledButton>
  );
};

export default memo(InfoButton);
